<app-header [forceLightBackground]="true"></app-header>
<div class="admin-support">
  <div class="admin-support--layout">
    <app-admin-sidebar class="admin-support--sidebar"></app-admin-sidebar>
    <div class="admin-support--content">
      <app-page-header></app-page-header>
      <div class="support--container">
        <app-support></app-support>
      </div>
    </div>
  </div>
</div>



